import { createTableConfig } from "@di-devs/utils-fe";
import { Table, type TablePaginationConfig, type TableProps } from "antd";
import type React from "react";
import { useAudienceContext } from "../providers/AudienceContext";
import type { AudienceData } from "../types";

export interface AudienceTableProps<T = AudienceData>
	extends Omit<TableProps<T>, "dataSource" | "rowSelection"> {
	data: T[];
	emptyText?: string;
}

function AudienceTable<T = AudienceData>({
	data,
	columns,
	loading,
	emptyText = "オーディエンスのデータがありません",
	pagination = false,
	scroll,
	size = "small",
	bordered = true,
	...props
}: AudienceTableProps<T>) {
	const { publicSettings } = useAudienceContext();

	const defaultPagination: false | TablePaginationConfig =
		pagination === false ? pagination : createTableConfig(pagination);

	const defaultScroll = scroll || {
		x: 640,
		y: 720,
	};

	return (
		<Table<T>
			dataSource={data}
			columns={columns}
			loading={loading}
			pagination={defaultPagination}
			scroll={defaultScroll}
			size={size}
			bordered={bordered}
			locale={{
				emptyText,
				triggerDesc: "降順でソート",
				triggerAsc: "昇順でソート",
				cancelSort: "ソートをキャンセル",
			}}
			className="audience-table"
			rowClassName={(_record, index) =>
				index % 2 === 0 ? "bg-white" : "bg-gray-50"
			}
			style={
				{
					"--primary-color":
						publicSettings?.PRIMARY_COLOR?.valueString || "#1890ff",
					"--primary-light-color":
						publicSettings?.PRIMARY_LIGHT_COLOR?.valueString || "#f0f5ff",
				} as React.CSSProperties
			}
			{...props}
		/>
	);
}

export default AudienceTable;
